import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './app/app-rout/routes';
import { Box, ChakraProvider } from '@chakra-ui/react';
import theme from './styles/theme';
import './fonts.css';
import Header from './components/header/header';
import { Global } from '@emotion/react';



const App: React.FC = () => {
  return (
    <ChakraProvider theme={theme}>

      <Global
        styles={{
          // Global styles for the scrollbar and overflow handling
          body: {
            margin: 0,
            padding: 0,
            boxSizing: "border-box",
            overflowX: "hidden", 
            overflowY: "auto", 
          },
          // Custom scrollbar styles
          '&::-webkit-scrollbar': {
            width: '5px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#1C1C1C',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#FFFFF',
            borderRadius: '24px',
            border: '2px solid #f1f1f1',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
        }}
      />

      <Router>
        <Routes />
      </Router>
    </ChakraProvider>
  );
};

export default App;

